<template>
  <div class="view-login">
    <div class="container mt-4">
      <h5 class="font-weight-normal text-center text-muted">Please sign in with your company login details</h5>
      <div class="row justify-content-center">
        <div class="col-lg-6 col-xl-4">
          <div class="login-form pt-1">
            <form name="loginform" id="loginform" v-on:submit.prevent="">
              <div v-if="loginAPIerror !== ''" class="alert alert-danger" role="alert">
                {{loginAPIerror}}
              </div>
              <transition name="fade">
                <div v-if="checkingCredentials" class="alert alert-info">
                  <Loading loading-message="Checking your login credentials"></Loading>
                </div>
              </transition>
              <div class="form-group">
                <label for="username">Email Address</label>
                <input required type="text" name="log" v-model="username" id="username" placeholder="Your company username or email" class="form-control" value="" size="20">
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input required type="password" name="pwd" v-model="password" id="password" placeholder="Your company password" class="form-control" value="" size="20">
              </div>
              <div class="form-check">
                <input name="rememberme" type="checkbox" class="form-check-input" v-model="rememberme" id="rememberme" value="forever">
                <label for="rememberme">Remember me</label>
              </div>
              <div class="form-group">
                <input v-on:click="loginToWordpress()" type="submit" class="btn btn-primary" value="Log In">
              </div>
            </form>
          </div>
        </div>
      </div>
      <TextSlider></TextSlider>
    </div>
  </div>
</template>

<script>
import TextSlider from '@/components/TextSlider'
import Loading from '@/components/Loading'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ADauthentication from '@/helpers/ADauthentication.js'
import authentication from '@/authentication'
export default {
  components: {
    TextSlider,
    Loading
  },
  data () {
    return {
      username: '',
      password: '',
      rememberme: false,
      loginAPIerror: '',
      checkingCredentials: false,
      userAzureDetails: {}
    }
  },
  created () {
    console.log(' created called 63 ')
    this.userAzureDetails = authentication.getUserProfile()
    if (this.userAzureDetails) {
      this.username = this.userAzureDetails.upn.toLowerCase()
      if (this.$store.getters.isAdmin) {
        this.password = this.userAzureDetails.upn.toLowerCase()
      }
      else {
        this.password = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
      }
      console.log('created checkHasThinkTankAccount called ')
      this.checkHasThinkTankAccount()
    }
    console.log('created after if  ')
    document.title = this.$route.name + ' - ThinkTank'
    if (localStorage.getItem('usernameRemembered') !== null && localStorage.getItem('passwordRemembered') !== null) {
      console.log('created 79')    
      this.username = localStorage.getItem('usernameRemembered')
      this.password = localStorage.getItem('passwordRemembered')
      this.rememberme = true
    }
  },
  methods: {
    updateUserPswrd: function (id) {
      WordpressRestAPI.updatePassword(id, this.password)
        .then(response => {
          console.log(' updateUserPswrd  ', response)
          this.password += '@#41322368' + id
          this.loginToWordpress()
        })
        .catch(e => {
          console.error(e)
        })
    },
    loginToWordpress: function () {
      console.log('loginToWordpress called 94 ')
      this.checkingCredentials = true
      if (this.username.indexOf('\\') === -1) {
        this.$store.dispatch('login', {username: this.username, password: this.password, rememberme: this.rememberme})
          .then(response => {
            console.log('loginToWordpress called 98 ', response)  
            this.checkingCredentials = false
            this.$store.dispatch('userDetails')
              .then(response => {
                console.log('loginToWordpress response userDetails', response)
                console.log('loginToWordpress Redirectlink info-> ', localStorage.getItem("adal.login.request"))
                // console.log('Redirectlink path-> ', localStorage.getItem("Redirectlink").split('#')[1] )
                if (localStorage.getItem("adal.login.request") !== '' && localStorage.getItem("adal.login.request").indexOf('login') > -1) {
                  let redirectPath = localStorage.getItem("adal.login.request").split('login')[1]
                  this.$router.push( redirectPath.replace(/\+/g, '/') )
                  localStorage.setItem("adal.login.request", '/')
                } else if (this.$route.params.return === undefined) {
                // if (this.$route.params.return === undefined) {
                  console.log(' loginToWordpress before redirect ')
                  this.$router.push('/')
                } else if (response === 'User not found') {
                  this.$router.push('/login')
                } else {
                  this.$router.push({ path: '/' + this.$route.params.return.replace(/\+/g, '/'), query: this.$route.query})
                }
              })
          })
          .catch(error => {
            console.log(error)
            this.authenticateADuser()
          })
      } else {
        console.log('loginToWordpress 125')
        this.authenticateADuser()
      }
    },
    createUser: function (userDetails) {
      console.log('createUser called 135')
      WordpressRestAPI.createThinkTankUser({
        email: userDetails.email,
        userName: (userDetails.UPN !== '') ? userDetails.UPN : userDetails.email,
        password: userDetails.password,
        firstname: userDetails.firstname,
        lastname: userDetails.lastname,
        department: userDetails.department,
        country: userDetails.country,
        employeenumber: userDetails.employeenumber,
        company: userDetails.company
      }, this.password)
        .then(response => {
          console.log(response)
          console.log('domainuser -> ' + this.username)
          if (this.username.indexOf('\\') > -1) {
            this.username = userDetails.email
            console.log('createUser updated-> ' + this.username)
            this.loginToWordpress()
          } else {
            console.log(' createUser before calling loginToWordpress 155 ')  
            this.loginToWordpress()
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    getUserDetails: function () {
      console.log('getUserDetails called 164 ')    
      ADauthentication.getUserInfoByEmail(this.username)
        .then(response => {
          console.log('getUserDetails called before calling createUser')    
          this.createUser(response.data)
        })
        .catch(e => {
          console.error(e)
        })
    },
    registerThinkTankUser: function () {
      console.log(' registerThinkTankUser called before getUserDetails')
      this.getUserDetails()
    },
    checkHasThinkTankAccount: function () {
      console.log('checkHasThinkTankAccount 169')
      // Second check if user has ThinkTank account in Wordpress
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getReplicateUser?email=' + this.username)
      .then(ReplicateResponse => {
        console.log('checkHasThinkTankAccount this response ', ReplicateResponse)
        if (ReplicateResponse && ReplicateResponse.data != '') {
          this.username = ReplicateResponse.data
        }
        
        WordpressRestAPI.getCustomViewContent('thinktank_authentication/v1/validateUserThinktank?search=' + this.username)
        .then(response => {
          // If response is empty then we must add the user to ThinkTank
          if (response.data === false) {
            console.log(' checkHasThinkTankAccount 174 ')  
            this.registerThinkTankUser()
          } else {
            console.log(' checkHasThinkTankAccount 177 ')
            // If user exists on ThinkTank log them in and change their password to AD Password
            this.updateUserPswrd(response.data)
          }
        })
        .catch(e => {
          console.error(e)
        })
        
        /*WordpressRestAPI.getViewContent('users?search=' + this.username)
        .then(response => {
          console.log('checkHasThinkTankAccount 173', response, this.username)
          // If response is empty then we must add the user to ThinkTank
          if (response.data.length === 0) {
            console.log('checkHasThinkTankAccount 175')  
            //this.registerThinkTankUser()
          } else {
            console.log('checkHasThinkTankAccount 179')  
            // If user exists on ThinkTank log them in and change their password to AD Password
            //this.updateUserPswrd(response.data[0].id)
          }
        })
        .catch(e => {
          console.error(e)
        })*/
        console.log(' this.username ', this.username)
      })
      .catch(e => {
        console.error(e)
      })
    },
    authenticateADuser: function () {
      console.log('authenticateADuser called')
      this.checkingCredentials = true

      ADauthentication.authenticate(this.username, this.password)
        .then(response => {
          console.log(' authenticateADuser ', response)
          if (response === true) {
            console.log('authenticateADuser called 196')  
            this.checkHasThinkTankAccount()
          } else {
            this.checkingCredentials = false
            this.loginAPIerror = 'Incorrect login details. Please try changing your email or password'
          }
        })
        .catch(e => {
          console.error(e)
          this.checkingCredentials = false
          this.loginAPIerror = 'Incorrect login details. Please try changing your email or password'
        })
    }
  }
}
</script>

<style lang="less">
  .view-login {
    min-height: calc(100vh - 295px);
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/Login.vue